import {
  Divider as BaseDivider,
  DividerProps as BaseDividerProps,
} from 'components/common'

export interface ModalDividerProps extends BaseDividerProps {}

export const Divider = ({ style, ...rest }: ModalDividerProps): JSX.Element => (
  <>
    <BaseDivider
      style={{ ...style, marginLeft: -24, marginRight: -24, width: 'auto' }}
      {...rest}
    />
  </>
)
